import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import { proxyCounterpart } from '../../scripts/proxyCounterpart';

const PaymentCancel = ({payment}) => {
  return (
    <div className='payment-page'>
      <header>
        <Translate content='PAYMENT_CANCEL_TITLE'/>
      </header>
      <section>
        <p dangerouslySetInnerHTML={{__html: proxyCounterpart('PAYMENT_CANCEL_MESSAGE')}} />
        <a className="btn" href={`/payment/${payment.invoice.data.uuid}`}>
          <Translate content='PAYMENT_CANCEL_TRY_AGAIN'/>
        </a>
      </section>
    </div>
  );
};

PaymentCancel.propTypes = {payment: PropTypes.object.isRequired};

export default PaymentCancel;



/** WEBPACK FOOTER **
 ** ./src/views/payment/payment-cancel.js
 **/